export default {
  data() {
    return {
      formLoading: false,
      formError: null,
      formErrors: null,
      formMessage: null,
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.formLoading = true;
      this.clearFormErrors();
      this.$store.dispatch(this.storeDispatchTarget, { ...this.form })
        .then(
          () => {
            if (this.routerTarget) {
              this.$router.push(this.routerTarget);
            }
          },
          (r) => {
            this.handleFormErrors(r.response.data);
          },
        ).finally(() => { this.formLoading = false; });
    },
    handleFormErrors(responseObject) {
      this.clearFormErrors();
      if (typeof responseObject.error === 'string') {
        this.formError = responseObject.error;
      } else if (typeof responseObject.errors === 'string') {
        this.formError = responseObject.errors;
      } else if (responseObject.errors) {
        this.formErrors = responseObject.errors;
      }
      if (this.formError) {
        this.$root.$emit('notification-add', { content: this.formError, variant: 'danger' });
      }

      // if no error was handled
      if (!this.formError && !this.formErrors) {
        this.$root.$emit('notification-add', {
          content: responseObject.message, variant: 'danger',
        });
      }

      // concatenate all errors
      let errorMessage = '';
      if (this.formError) errorMessage += `${this.formError}\n`;
      if (this.formErrors) {
        Object.keys(this.formErrors).forEach((field) => {
          errorMessage += `${this.formErrors[field].join('\n')}\n`;
        });
      }
      return errorMessage;
    },
    clearFormErrors() {
      this.formErrors = null;
      this.formError = null;
    },
  },
  computed: {
    validate() {
      return (value, type) => {
        if (type === 'email') {
          if (value.length > 10) { return true; }
        }
        return false;
      };
    },
  },
};
